import gql from 'graphql-tag';

export const GET_LIST_OF_PROPOSALS_BY_CREDIT_SUBMISSION = gql`
  query GetListOfProposalsByCreditSubmission($creditSubmissionId: ID!, $input: ProposalsWithPaginationInput!) {
    proposals: listOfProposalsByCreditSubmission(creditSubmissionId: $creditSubmissionId, input: $input) {
      page
      total
      perPage
      totalPages
      data {
        status
        fullName
        lastName
        firstName
        businessName
        id: proposalId
        salesPersonName
        createdDateTime
      }
    }
  }
`;
